/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardUpdateRequest
 */
export interface DashboardUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardUpdateRequest
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof DashboardUpdateRequest
     */
    order?: number;
}

/**
 * Check if a given object implements the DashboardUpdateRequest interface.
 */
export function instanceOfDashboardUpdateRequest(value: object): value is DashboardUpdateRequest {
    return true;
}

export function DashboardUpdateRequestFromJSON(json: any): DashboardUpdateRequest {
    return DashboardUpdateRequestFromJSONTyped(json, false);
}

export function DashboardUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function DashboardUpdateRequestToJSON(json: any): DashboardUpdateRequest {
    return DashboardUpdateRequestToJSONTyped(json, false);
}

export function DashboardUpdateRequestToJSONTyped(value?: DashboardUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'order': value['order'],
    };
}

